<template>
  <div class="Fiche__image">
    <api-picture
      v-if="pic"
      :picture-id="pic.picture.id"
      :style="{ maxHeight: `calc(100% - ${offset}px)` }"
      :size="size ? size : 2000"
      :lazy="false"
      @rawLoad="dimension"
    ></api-picture>
    <h5
      v-if="pic && pic.text && pic.text.trim() !== ''"
      :style="{ maxWidth: `${w}px` }"
      class="text-moyen image-caption"
    >
      {{ pic.text | mo }}
    </h5>
  </div>
</template>
<script>
import { objectFitImageRealDims } from "../../../../../util/func";
import ApiPicture from "../../../../../components/Form/ApiPicture";

export default {
  name: "image-fiche",
  components: { ApiPicture },
  data() {
    return {
      offset: 0,
      w: 9999
    };
  },
  props: {
    p: {},
    pm: {},
    size: {
      type: Number,
      required: false
    }
  },
  computed: {
    mapProps() {
      const b = this.p.contents.find(a => a.axe_id === this.pm.axe);
      return b
        ? b.pictures.find(p => p && p.picture_id === this.pm.axe_image)
        : null;
    },
    pic() {
      const b = this.p.contents_d.find(a => a.axe_id === this.pm.axe);
      return b
        ? b.pictures.find(
            p => p && p.picture && p.picture.id === this.pm.axe_image
          )
        : null;
    }
  },
  methods: {
    async dimension() {
      this.w = 9999;
      await new Promise(r => setTimeout(r, 50));
      let a = this.$el && this.$el.querySelector(".image-caption");
      if (!a) return;
      while (this.offset !== a.getBoundingClientRect().height) {
        this.offset = a.getBoundingClientRect().height;
        this.w = objectFitImageRealDims(this.$el.querySelector("img")).width;
        await new Promise(r => setTimeout(r, 50));
      }
      this.w = objectFitImageRealDims(this.$el.querySelector("img")).width;
      this.offset = a.getBoundingClientRect().height;
    }
  },
  async mounted() {
    this.dimension();
  },
  watch: {
    pm: {
      deep: true,
      async handler() {
        this.dimension();
      }
    }
  }
};
</script>
